
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle, runWithConsole, runTestCasesWithTimeout} = await import("./lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("runWithConsole" in module)) throw new SyntaxError(`export 'runWithConsole' not found`);
  if (!("runTestCasesWithTimeout" in module)) throw new SyntaxError(`export 'runTestCasesWithTimeout' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, ok, err, hint, consoleOutput, testReport } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,runWithConsole,runTestCasesWithTimeout,codeEditor,ok,err,hint,consoleOutput,testReport};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","runWithConsole","runTestCasesWithTimeout","codeEditor","ok","err","hint","consoleOutput","testReport"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: (view,codeEditor) => {
const demo_basics = view(codeEditor("arrays:basics", {
  value: 'const fruits = ["Apfel", "Orange", "Banane"]\nconst ages = [22, 90, 18, 7, 45]\nconst heroes = ["Hulk", "Thor"]\n\nconsole.log(fruits)\nconsole.log(ages)\nconsole.log(heroes)'
}));
return {demo_basics};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_basics"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-6`),
    expanded: [],
    variables: []
  },
  {
    id: 6,
    body: async (display,consoleOutput,runWithConsole,demo_basics) => {
display(consoleOutput(await runWithConsole(demo_basics)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_basics"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-9`),
    expanded: [],
    variables: []
  },
  {
    id: 9,
    body: (view,codeEditor) => {
const demo_index = view(codeEditor("arrays:index", {
  value: 'const colors = ["Blau", "Rot", "Orange", "Grün"]\n\nconsole.log(colors[0]) // Blau\nconsole.log(colors[2]) // Orange\nconsole.log(colors[3]) // Grün\n\n// Was passiert bei einem Index, den es nicht gibt?\nconsole.log(colors[10]) // undefined'
}));
return {demo_index};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_index"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-10`),
    expanded: [],
    variables: []
  },
  {
    id: 10,
    body: async (display,consoleOutput,runWithConsole,demo_index) => {
display(consoleOutput(await runWithConsole(demo_index)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_index"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-12`),
    expanded: [],
    variables: []
  },
  {
    id: 12,
    body: (view,codeEditor) => {
const demo_assign = view(codeEditor("arrays:assign", {
  value: 'const drinks = ["Wasser", "Saft", "Cola"]\nconsole.log(drinks)\n\ndrinks[1] = "Limonade"\nconsole.log(drinks)'
}));
return {demo_assign};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_assign"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-13`),
    expanded: [],
    variables: []
  },
  {
    id: 13,
    body: async (display,consoleOutput,runWithConsole,demo_assign) => {
display(consoleOutput(await runWithConsole(demo_assign)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_assign"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-15`),
    expanded: [],
    variables: []
  },
  {
    id: 15,
    body: (view,codeEditor) => {
const demo_builtins = view(codeEditor("arrays:builtins", {
  value: 'const numbers = [10, 20, 30, 40, 50]\n\nconsole.log(numbers.length)        // 5\nconsole.log(numbers.includes(30))  // true\nconsole.log(numbers.includes(99))  // false\nconsole.log(numbers.indexOf(40))   // 3\nconsole.log(numbers.slice(1, 4))   // [20, 30, 40]'
}));
return {demo_builtins};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_builtins"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-16`),
    expanded: [],
    variables: []
  },
  {
    id: 16,
    body: async (display,consoleOutput,runWithConsole,demo_builtins) => {
display(consoleOutput(await runWithConsole(demo_builtins)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_builtins"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-18`),
    expanded: [],
    variables: []
  },
  {
    id: 18,
    body: (view,codeEditor) => {
const demo_modify = view(codeEditor("arrays:modify", {
  value: 'const todos = ["Wäsche", "Einkaufen"]\n\ntodos.push("Aufräumen")\nconsole.log(todos) // ["Wäsche", "Einkaufen", "Aufräumen"]\n\ntodos.unshift("Aufstehen")\nconsole.log(todos) // ["Aufstehen", "Wäsche", "Einkaufen", "Aufräumen"]\n\nconst entfernt = todos.pop()\nconsole.log(entfernt) // "Aufräumen"\nconsole.log(todos)    // ["Aufstehen", "Wäsche", "Einkaufen"]'
}));
return {demo_modify};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_modify"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-19`),
    expanded: [],
    variables: []
  },
  {
    id: 19,
    body: async (display,consoleOutput,runWithConsole,demo_modify) => {
display(consoleOutput(await runWithConsole(demo_modify)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_modify"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-21`),
    expanded: [],
    variables: []
  },
  {
    id: 21,
    body: (view,codeEditor) => {
const demo_nested = view(codeEditor("arrays:nested", {
  value: 'const ticTacToe = [\n  ["X", "O", "X"],\n  ["O", "X", "O"],\n  ["O", "X", "X"]\n]\n\nconsole.log(ticTacToe[0])    // erste Zeile\nconsole.log(ticTacToe[1][1]) // Mitte: "X"\n// (ticTacToe[1])[1] — erst die zweite Zeile holen, dann das mittlere Element'
}));
return {demo_nested};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_nested"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-22`),
    expanded: [],
    variables: []
  },
  {
    id: 22,
    body: async (display,consoleOutput,runWithConsole,demo_nested) => {
display(consoleOutput(await runWithConsole(demo_nested)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_nested"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-24`),
    expanded: [],
    variables: []
  },
  {
    id: 24,
    body: (view,codeEditor) => {
const demo_forof = view(codeEditor("arrays:forof", {
  value: 'const devices = ["Laptop", "Tablet", "Handy"]\n\nfor (const device of devices) {\n  console.log("Ich besitze ein " + device + ".")\n}'
}));
return {demo_forof};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_forof"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-25`),
    expanded: [],
    variables: []
  },
  {
    id: 25,
    body: async (display,consoleOutput,runWithConsole,demo_forof) => {
display(consoleOutput(await runWithConsole(demo_forof)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_forof"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-27`),
    expanded: [],
    variables: []
  },
  {
    id: 27,
    body: (view,codeEditor) => {
const uebung_code = view(codeEditor("arrays:final", {
  value: ""
}));
return {uebung_code};
},
    inputs: ["view","codeEditor"],
    outputs: ["uebung_code"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-28`),
    expanded: [],
    variables: []
  },
  {
    id: 28,
    body: (runTestCasesWithTimeout,uebung_code) => {
const uebungResult = runTestCasesWithTimeout({
  code: uebung_code,
  fnName: "filterStrings",
  cases: [
    [[["Kugelschreiber", "Salz", "Maus"]], ["Salz", "Kugelschreiber"]],
    [[["Sun", "Stars", "Moon", "Galaxy"]], ["Galaxy", "Stars", "Sun"]],
    [[[]], []],
    [[["abc", "xy"]], []],
    [[["Snake", "Anna"]], ["Snake"]],
    [[["NaSe", "Sand", "ok"]], ["Sand"]]
  ]
});
return {uebungResult};
},
    inputs: ["runTestCasesWithTimeout","uebung_code"],
    outputs: ["uebungResult"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-29`),
    expanded: [],
    variables: []
  },
  {
    id: 29,
    body: (display,testReport,uebungResult) => {
display(testReport(uebungResult, "filterStrings"));
},
    inputs: ["display","testReport","uebungResult"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
